var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9755 1.08156L13.9432 7.13729C14.144 7.75532 14.7199 8.17376 15.3697 8.17376H21.7371C22.2215 8.17376 22.4229 8.79357 22.031 9.07827L16.8797 12.8209C16.354 13.2029 16.134 13.8799 16.3348 14.498L18.3024 20.5537C18.4521 21.0143 17.9248 21.3974 17.533 21.1127L12.3817 17.3701C11.8559 16.9881 11.1441 16.9881 10.6183 17.3701L5.46701 21.1127C5.07516 21.3974 4.54791 21.0144 4.69759 20.5537L6.66522 14.498C6.86603 13.8799 6.64604 13.2029 6.12031 12.8209L0.968998 9.07827C0.577142 8.79357 0.778528 8.17376 1.26289 8.17376H7.63026C8.2801 8.17376 8.85604 7.75532 9.05685 7.13729L11.0245 1.08156C11.1741 0.620904 11.8259 0.620902 11.9755 1.08156Z",
    stroke: "#64739A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarOutlined);
export default __webpack_public_path__ + "static/media/star-outlined.cfb0c3ea31e304550e3953e6bfdb9871.svg";
export { ForwardRef as ReactComponent };